import './styles.scss'

import { useLayoutEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Carousel, Empty } from 'antd'

import { ChevronLeftIcon, ChevronRightIcon } from '@/components/Icons'
import { NotificationManager } from '@/components/Notification'

import SpecialItem from './components/SpecialItem'
import { usePromotionQuery } from './usePromotionQuery'

function SpecialsForYou() {
  const { t } = useTranslation()

  const [containerWidth, setContainerWidth] = useState(0)
  const containerRef = useRef(null)
  const { data, isFetching, isError } = usePromotionQuery()

  if (isError) {
    NotificationManager.error({
      message: 'notification.error.promotionData',
    })
  }

  useLayoutEffect(() => {
    if (containerRef.current) {
      setContainerWidth(containerRef.current.offsetWidth)
    }
  }, [])

  const renderLoadingState = () => {
    return Array.from(Array.from({ length: 6 }).keys()).map((key) => (
      <SpecialItem key={key} isLoading={isFetching} />
    ))
  }

  const renderStaticItems = () => (
    <div className="specials-for-you__items__wrapper">
      <div className="specials-for-you__items__wrapper--inner">
        {data?.map((item) => (
          <div key={item.materialNumber}>
            <SpecialItem
              currencyUnit={item.currencyUnit}
              img={{ src: item.pictureUrl, alt: item.materialName }}
              isLoading={isFetching}
              listPrice={item.listPrice}
              materialNumber={item.materialNumber}
              name={item.materialName}
            />
          </div>
        ))}
      </div>
    </div>
  )

  const renderCarousel = () => (
    <div className="specials-for-you__carousel">
      <Carousel
        arrows
        infinite
        variableWidth
        className="specials-for-you__carousel__container"
        dots={{ className: 'specials-for-you__carousel__dots' }}
        nextArrow={<ChevronRightIcon />}
        prevArrow={<ChevronLeftIcon />}
        slidesToScroll={1}
        speed={1000}
      >
        {isFetching
          ? renderLoadingState()
          : data?.map((item) => (
            <SpecialItem
              key={item.materialNumber}
              currencyUnit={item.currencyUnit}
              img={{ src: item.pictureUrl, alt: item.materialName }}
              isLoading={isFetching}
              listPrice={item.listPrice}
              materialNumber={item.materialNumber}
              name={item.materialName}
            />
          ))}
      </Carousel>
    </div>
  )

  const renderItems = () => {
    if (isFetching) {
      return renderCarousel()
    }
    const numberOfItems = data?.length
    if (numberOfItems > 0) {
      // each item width = 320px + 24px (padding right)
      if (containerWidth > (320 + 24) * numberOfItems) {
        return renderStaticItems()
      }
      return renderCarousel()
    }
    return (
      <div className="specials-for-you__items__wrapper">
        <Empty description={t('noData')} />
      </div>
    )
  }

  return (
    <div ref={containerRef} className="specials-for-you__wrapper">
      <h2 className="text-xl font-bold">
        {t('myWorkspace.specialsForYou.title')}
      </h2>
      {renderItems()}
    </div>
  )
}

export default SpecialsForYou
